import { render } from "./ParametersTable.vue?vue&type=template&id=aa1ddb32"
import script from "./ParametersTable.vue?vue&type=script&lang=js"
export * from "./ParametersTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__